import React from 'react'

import ActionButton, {
  ActionButtonSize,
  ActionButtonType,
} from '$extensionSrc/components/ActionButton'

import styles from './LoginSignupOAuthOnly.module.scss'

export default function LoginSignupOAuthOnly({
  tenantName,
  oauthOptions,
  action,
}: {
  tenantName: string
  oauthOptions: { name: string; url: string }[]
  action: 'login' | 'signup'
}) {
  const actionText = action === 'login' ? 'Login to' : 'Sign up for'
  return (
    <div className={styles.LoginSignupOAuthOnly}>
      <div className={styles.formBody}>
        <h1 className="heading1 bold">
          {actionText} {tenantName}
        </h1>
        <div className={styles.oauthOptions}>
          {oauthOptions.map(({ name: oauthOptionName, url }) => (
            <ActionButton
              type={ActionButtonType.SECONDARY}
              size={ActionButtonSize.LARGE}
              key={oauthOptionName}
              onClick={() => {
                window.location.href = url
              }}
            >
              Continue with {oauthOptionName}
            </ActionButton>
          ))}
        </div>
      </div>
    </div>
  )
}
